import { UploadService } from 'modules/common/service';
import { ICategory } from 'modules/inventory/settings/category/interfaces';
import { IImageMedia } from 'modules/common/interfaces';

class CategoryUploadService extends UploadService<ICategory> {
  uploadImage = (file: File | undefined): Promise<IImageMedia> => {
    return this.upload('/image/upload', file);
  };
}

export default new CategoryUploadService('/ms-inventory/api/categories');
